import { t } from 'i18next'
import React, { forwardRef } from 'react'

import { DefaultButton } from '../DefaultButton/DefaultButton'
import { VisuallyHidden } from '../Layout/Layout'
import SmallLoader from '../Loader/SmallLoader'

type Props = {
  onClick: () => void
  isLoading: boolean
  dataCy?: string
}

const LoadingButton = forwardRef<HTMLButtonElement, Props>(
  ({ onClick, isLoading, dataCy }, ref) => {
    return (
      <>
        <VisuallyHidden role="status" aria-relevant="all">
          {isLoading ? t('common.loadingText') : ''}
        </VisuallyHidden>
        <DefaultButton
          ref={ref}
          onClick={() => {
            if (!isLoading) {
              onClick()
            }
          }}
          variant="outlined"
          data-cy={dataCy}
          aria-label={isLoading ? t('common.loadingText') : t('common.showMore')}
          aria-disabled={isLoading}
        >
          {isLoading ? <SmallLoader /> : t('common.showMore')}
        </DefaultButton>
      </>
    )
  }
)

export default LoadingButton
